import { useState } from 'react';
import BannerCarousel from '@/pages/Landing/BannerCarousel';
import FeaturedPostsList from '@/redux/post/FeaturedPostsList';
import { Title } from '@/components/ui/title';
import { useGetFeaturedPostsQuery } from '@/redux/post/post.api.slice';
import Hero from './Hero';
import FeaturedStrip from './FeaturedStrip';
import { useGetSpotlightQuery } from '@/redux/spotlight/spotlight.api.slice';

const FEATURED_LIMIT = 12;
const STRIP_SIZE = 4;

function Landing() {
  const [postCount, setPostCount] = useState(0);
  const { data: featured } = useGetFeaturedPostsQuery({
    limit: FEATURED_LIMIT,
  });
  const { data: spotlight } = useGetSpotlightQuery();
  // The hero already carries the file of the week; don't show it twice.
  const strip = (featured ?? [])
    .filter((item) => item._id !== spotlight?.fileOfTheWeek?._id)
    .slice(0, STRIP_SIZE);

  return (
    <div>
      {/* Padded rather than offset, so the field carries on behind the glass navbar. */}
      <section
        style={{ paddingTop: 'calc(var(--nav-height) + 1.5rem)' }}
        className="relative overflow-hidden bg-gradient-to-b from-green-100 via-emerald-50 via-45% to-background to-88% px-4 pb-8 sm:px-[48px]"
      >
        <span
          aria-hidden
          className="pointer-events-none absolute -left-20 top-8 h-72 w-72 rounded-full bg-green-400/30 blur-3xl"
        />
        <span
          aria-hidden
          className="pointer-events-none absolute -right-16 top-40 h-80 w-80 rounded-full bg-emerald-300/35 blur-3xl"
        />
        <span
          aria-hidden
          className="pointer-events-none absolute bottom-32 left-1/3 h-64 w-64 rounded-full bg-teal-300/20 blur-3xl"
        />
        {/* Above the glow, or the blobs wash the dots out where they overlap;
            masked at the foot so the field thins out into the feed. */}
        <span
          aria-hidden
          className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle,rgba(4,120,87,0.13)_1px,transparent_1px)] [background-size:12px_12px] [-webkit-mask-image:linear-gradient(to_bottom,black_55%,transparent_95%)] [mask-image:linear-gradient(to_bottom,black_55%,transparent_95%)]"
        />

        <div className="relative mx-auto w-full max-w-[1400px]">
          <Hero />

          <FeaturedStrip items={strip} />

          <div className="mt-10">
            <BannerCarousel />
          </div>
        </div>
      </section>

      {/* The navbar's brand row folds away from here down — see useHideOnScroll. */}
      <div id="top-results" className="px-4 pb-24 sm:px-[48px]">
        <div className="flex items-center gap-2">
          <Title title="Top Results" />
          {postCount > 0 && (
            <span className="text-sm text-muted-foreground font-medium">
              ({postCount})
            </span>
          )}
        </div>
        <div className="w-full">
          <FeaturedPostsList onCountChange={setPostCount} />
        </div>
      </div>
    </div>
  );
}

export default Landing;
